<template>
    <v-sheet>
        <v-fade-transition>
            <v-overlay absolute v-show="ready">
                <youtube
                    v-bind="{
                        videoId: parse(lecture?.video?.link)?.id,
                        width,
                        height,
                        playerVars: {
                            autoplay: 1,
                        },
                    }"
                    fitParent
                    class="mb-n6"
                    @ready="check"
                />
            </v-overlay>
        </v-fade-transition>
        <v-fade-transition>
            <v-overlay v-show="!ready" absolute color="transparent">
                <v-progress-circular size="100" width="5" color="primary" indeterminate />
            </v-overlay>
        </v-fade-transition>
    </v-sheet>
</template>

<script>
import urlParser from "js-video-url-parser";

import { mapState } from "vuex";

export default {
    props: {
        width: { type: Number, default: 640 },
        height: { type: Number, default: 320 },
    },
    data: () => ({
        ready: false,
    }),
    computed: {
        ...mapState("lecture", ["lecture"]),
    },
    methods: {
        parse: urlParser.parse,
        check() {
            this.ready = true;
        },
    },
};
</script>

<style>
</style>